import React from 'react';
import { Star, Quote, ArrowLeft } from 'lucide-react';
import { testimonials } from '../data/mock';

const AllTestimonialsPage = () => {
  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-page">
      {/* Header */}
      <header className="header-nav">
        <div className="container flex items-center justify-between">
          <button onClick={goBack} className="flex items-center gap-2 text-primary hover:text-accent-purple-400 transition-colors">
            <ArrowLeft size={20} />
            <span>Volver</span>
          </button>
          <div className="text-xl font-semibold text-primary">
            DerMa Centro Dermatológico
          </div>
          <div></div>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-24 pb-16">
        <div className="container">
          {/* Page Header */}
          <div className="text-center mb-16">
            <h1 className="heading-1 mb-4">Más Testimonios</h1>
            <p className="body-large text-secondary max-w-2xl mx-auto">
              Lee más experiencias de pacientes satisfechos que han confiado en nuestra atención dermatológica especializada.
            </p>
          </div>

          {/* All Testimonials Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((testimonial, index) => {
              const accentClasses = ['accent-purple', 'accent-blue', 'accent-orange', 'accent-pink', 'accent-green', 'accent-grey-200'];
              const accentClass = accentClasses[index % accentClasses.length];
              
              return (
                <div key={testimonial.id} className={`voice-card ${accentClass} hover-lift`}>
                  {/* Quote Icon and Rating */}
                  <div className="flex items-center justify-between mb-4">
                    <Quote size={24} className="text-primary/60" />
                    <div className="flex">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star key={i} size={14} className="text-accent-orange-400 fill-current" />
                      ))}
                    </div>
                  </div>

                  {/* Testimonial Text */}
                  <p className="voice-card-description mb-4 text-primary italic">
                    "{testimonial.text}"
                  </p>

                  {/* Patient Info */}
                  <div className="flex items-center justify-between mt-auto">
                    <div>
                      <div className="voice-card-title text-sm">{testimonial.name}</div>
                      <div className="caption">{testimonial.treatment}</div>
                    </div>
                    {testimonial.date && (
                      <div className="caption text-xs bg-white/30 px-2 py-1 rounded">
                        {testimonial.date}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-16">
            <div className="voice-card accent-purple inline-block p-8 max-w-lg">
              <h3 className="heading-3 mb-3">¿Listo para ser nuestro próximo paciente satisfecho?</h3>
              <p className="body-small text-secondary mb-4">
                Únete a los {testimonials.length} pacientes que ya han transformado su piel con nuestra atención especializada.
              </p>
              <button onClick={goBack} className="btn-primary">
                Agendar Mi Consulta
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AllTestimonialsPage;